<!-- Navbar -->
<div class="rounded-t-xl border border-input border-b-input bg-background flex items-stretch grow">
<!-- Container -->
<div class="kt-container-fluid flex justify-between items-stretch gap-5">
	<div class="grid items-stretch">
	<div class="kt-scrollable-x-auto flex items-stretch">
		<div class="kt-menu gap-5 lg:gap-7.5" data-kt-menu="true">
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div class="kt-menu-link gap-1.5" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				Account Home
			</span>
			<span class="kt-menu-arrow">
				<i class="ki-filled ki-down text-xs text-muted-foreground">
				</i>
			</span>
			</div>
			<div class="kt-menu-dropdown kt-menu-default py-2 min-w-[200px]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Dashboard
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Get Started
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					User Profile
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Company Profile
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Settings - With Sidebar
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Settings - Enterprise
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Settings - Plain
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Settings - Modal
				</span>
				</a>
			</div>
			</div>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div class="kt-menu-link gap-1.5" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				Billing
			</span>
			<span class="kt-menu-arrow">
				<i class="ki-filled ki-down text-xs text-muted-foreground">
				</i>
			</span>
			</div>
			<div class="kt-menu-dropdown kt-menu-default py-2 min-w-[200px]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Billing - Basic
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Billing - Enterprise
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Plans
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Billing History
				</span>
				</a>
			</div>
			</div>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div class="kt-menu-link gap-1.5" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				Security
			</span>
			<span class="kt-menu-arrow">
				<i class="ki-filled ki-down text-xs text-muted-foreground">
				</i>
			</span>
			</div>
			<div class="kt-menu-dropdown kt-menu-default py-2 min-w-[200px]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Get Started
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Security Overview
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Allowed IP Addresses
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Privacy Settings
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Device Management
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Backup & Recovery
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Current Sessions
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Security Log
				</span>
				</a>
			</div>
			</div>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div class="kt-menu-link gap-1.5" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				Members & Roles
			</span>
			<span class="kt-menu-arrow">
				<i class="ki-filled ki-down text-xs text-muted-foreground">
				</i>
			</span>
			</div>
			<div class="kt-menu-dropdown kt-menu-default py-2 min-w-[200px]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Teams Starter
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Teams
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Team Info
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Members Starter
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Team Members
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Import Members
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Roles
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Permissions - Toggler
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Permissions - Check
				</span>
				</a>
			</div>
			</div>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
			<a class="kt-menu-link gap-2.5" href="#" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				Integrations
			</span>
			</a>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
			<a class="kt-menu-link gap-2.5" href="#" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				Notifications
			</span>
			</a>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono">
			<a class="kt-menu-link gap-2.5" href="#" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				API Keys
			</span>
			</a>
		</div>
		<div class="kt-menu-item border-b-2 border-b-transparent kt-menu-item-active:border-b-mono kt-menu-item-here:border-b-mono" data-kt-menu-item-placement="bottom-start" data-kt-menu-item-placement-rtl="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="click|lg:hover">
			<div class="kt-menu-link gap-1.5" tabindex="0">
			<span class="kt-menu-title text-nowrap text-sm text-foreground kt-menu-item-active:text-mono kt-menu-item-active:font-medium kt-menu-item-here:text-mono kt-menu-item-here:font-medium kt-menu-item-show:text-mono kt-menu-link-hover:text-mono">
				More
			</span>
			<span class="kt-menu-arrow">
				<i class="ki-filled ki-down text-xs text-muted-foreground">
				</i>
			</span>
			</div>
			<div class="kt-menu-dropdown kt-menu-default py-2 min-w-[200px]">
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Appearance
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Invite a Friend
				</span>
				</a>
			</div>
			<div class="kt-menu-item">
				<a class="kt-menu-link" href="#" tabindex="0">
				<span class="kt-menu-title">
					Activity
				</span>
				</a>
			</div>
			</div>
		</div>
		</div>
	</div>
	</div>
	<div class="kt-menu kt-menu-default" data-kt-menu="true">
	<div class="flex items-center">
		<div class="kt-menu-item" data-kt-menu-item-offset="0, 0" data-kt-menu-item-placement="bottom-end" data-kt-menu-item-toggle="dropdown" data-kt-menu-item-trigger="hover">
		<button class="kt-menu-toggle kt-btn kt-btn-outline flex-nowrap">
			<span class="flex items-center me-1">
			<i class="ki-filled ki-calendar text-base!">
			</i>
			</span>
			<span class="hidden md:inline text-nowrap">
			September, 2025
			</span>
			<span class="inline md:hidden text-nowrap">
			Sep, 2025
			</span>
			<span class="flex items-center lg:ms-4">
			<i class="ki-filled ki-down text-xs!">
			</i>
			</span>
		</button>
		<div class="kt-menu-dropdown w-48 py-2 kt-scrollable-y max-h-[250px]">
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				January, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				February, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item active">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				March, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				April, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				May, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				June, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				July, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				August, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				September, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				October, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				November, 2024
				</span>
			</a>
			</div>
			<div class="kt-menu-item">
			<a class="kt-menu-link" href="#">
				<span class="kt-menu-title">
				December, 2024
				</span>
			</a>
			</div>
		</div>
		</div>
	</div>
	</div>
</div>
<!-- End of Container -->
</div>
<!-- End of Navbar -->